<template>
  <v-container>
    <v-row>
      <v-range-slider
        v-if="allProjectsData"
        :min="yearRange[0]"
        :max="yearRange[1]"
        thumb-label
        :tick-labels="ticksLabels"
        :value="projectYearFilters"
        @change="handleChange"
      />
    </v-row>
  </v-container>
</template>

<script>
// vuex
import { mapGetters, mapActions } from 'vuex'
// library
import _ from 'lodash'
// internal
// components
export default {
  name: 'SearchFilterYear',
  data() {
    return {
      tickFrequency: 5
    }
  },
  computed: {
    ...mapGetters(['allProjectsData', 'projectYearFilters']),
    yearRange() {
      if (!this.allProjectsData) return null

      const timestamps = this.allProjectsData
        .filter(el => el['go_live_date'] !== null)
        .map(el => {
          return new Date(el['go_live_date'])
        })

      return [_.min(timestamps).getFullYear(), _.max(timestamps).getFullYear()]
    },
    ticksLabels() {
      return _.range(this.yearRange[0], this.yearRange[1] + 1)
        .map(el => {
          if (el % this.tickFrequency === 0) {
            return el
          } else {
            return ''
          }
        })
        .map(el => `${el}`)
    }
  },
  watch: {
    yearRange(newValue) {
      if (!this.projectYearFilters) {
        this.setProjectYearFilters([newValue[0], newValue[1]])
      }
    }
  },
  mounted() {},
  methods: {
    ...mapActions(['setProjectYearFilters']),
    handleChange(value) {
      const stringValue = [...value].join(',')
      const currentQuery = { ...this.$route.query }
      const defaultValue = `${this.yearRange[0]},${this.yearRange[1]}`
      if (stringValue === defaultValue) {
        this.$router.history.push({
          path: '/',
          query: { ..._.omit(currentQuery, ['y']) }
        })
      } else {
        this.$router.history.push({
          path: '/',
          query: { ...currentQuery, y: stringValue }
        })
      }

      this.setProjectYearFilters(value)
    }
  }
}
</script>

<style lang="scss" scoped></style>
